import Button from "app/components/Button";
import DropdownIcon from "app/components/Icons/DropdownIcon";
import PlusIcon from "app/components/Icons/PlusIcon";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
import { ticketGroupsActions } from "app/containers/Features/containers/Boards/containers/Tickets/redux/slice";
import { selectTicketTypes } from "app/redux/selector";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectTicketFormDetail } from "../containers/Tickets/redux/selector";
import {
  findDefaultBoardTicketType,
  findDefaultBoardTypeName,
} from "../helpers";
import AddTaskModal from "./AddTaskModalComponent/AddTaskModal";
import {
  selectBoardForm,
  selectDraftBoardForm,
} from "./Settings/redux/selector";

export default function CreateTaskButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const form = useSelector(selectTicketFormDetail);
  const ticketTypes = useSelector(selectTicketTypes);
  const boardDraftForm = useSelector(selectDraftBoardForm);
  const boardForm = useSelector(selectBoardForm);

  const defaultType = useMemo(() => {
    return findDefaultBoardTicketType(
      ticketTypes || [],
      boardDraftForm.defaultTicketType,
    );
  }, [ticketTypes, boardDraftForm.defaultTicketType]);

  const defaultTypeName = useMemo(() => {
    return findDefaultBoardTypeName(
      ticketTypes || [],
      boardForm.defaultTicketType,
    );
  }, [ticketTypes, boardForm.defaultTicketType]);

  const handleTicketType = (value: string) => {
    dispatch(ticketGroupsActions.clearCreateTicket());
    dispatch(
      ticketGroupsActions.setTicketFormValue({ name: "type", value: value }),
    );
    setIsModalOpen(true);
  };
  const handleTicketTask = () => {
    dispatch(ticketGroupsActions.clearCreateTicket());
    dispatch(
      ticketGroupsActions.setTicketFormValue({
        name: "type",
        value: defaultType,
      }),
    );
    setIsModalOpen(true);
  };

  return (
    <div className="flex flex-col">
      <div className="flex">
        <Button
          onClick={handleTicketTask}
          className="text-secondary !p-0 h-[42px] text-sm leading-[21px] font-normal flex flex-row items-center hover:bg-[#4288E8] !rounded-r-none"
        >
          <div className="flex flex-row items-center gap-[4px] px-[10px]">
            <PlusIcon color="#FFFFFF" />
            <span className="text-sm leading-[21px] font-normal text-white mt-[2px]">
              {defaultTypeName}
            </span>
          </div>
        </Button>
        <CommonTicketTypeSelection
          setOpen={() => {
            setOpen(!open);
          }}
          trigger={
            <button
              className={` relative bg-primary text-white rounded-md px-4 py-2 focus:outline-none transition-all duration-300 text-secondary !p-0 h-[42px] text-sm leading-[21px] font-normal flex flex-row items-center hover:bg-[#4288E8] !rounded-l-none border-l border-[rgba(255,255,255,0.2)]${
                open ? "rotate-180" : "rotate-270"
              }
                      `}
            >
              <DropdownIcon size={20} color="#FFFFFF" />
            </button>
          }
          value={form?.type}
          setValue={(data) => {
            handleTicketType(data?._id);
          }}
          isHeader="TICKET TYPES"
          className="!w-[200px] py-2"
          isHeaderClassName="!text-[#79808A] !text-sm !font-semibold "
          showDefault
          align="end"
        />
      </div>
      {isModalOpen && <AddTaskModal onClose={() => setIsModalOpen(false)} />}
    </div>
  );
}
